import React, { FC } from 'react';
import { CUSTOM_FIELDS_TYPE_MAPPER } from 'src/models/procurements/Tender/mappers';
import Category from './Category';
import styles from './index.module.scss';
import { TenderBoxFieldType } from '@tendium/prom-types/tender';
import { groupFieldsByType, useAllCustomBidFields } from 'src/models/company/CustomBidFields/hooks';
import { Skeleton } from 'src/common';

interface IProps {
  readOnly: boolean;
}

export const CategoriesList: FC<IProps> = ({ readOnly }) => {
  const { data, loading } = useAllCustomBidFields();

  const customBidFields = groupFieldsByType(data?.getAllCustomBidFields || []);

  return (
    <>
      {loading && <Skeleton active={loading} />}
      {!loading && (
        <div className={styles.container}>
          {Object.entries(CUSTOM_FIELDS_TYPE_MAPPER).map(([key, val]) => (
            <Category
              key={key}
              readOnly={readOnly}
              type={key as TenderBoxFieldType}
              icon={val.defaultIcon}
              color={val.color}
              items={customBidFields[key]}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default CategoriesList;
